import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { isContactLensVariant } from '@grandvisionhq/fun-products';
import { createImpressionEvent, createInteractionEvent } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import { withLazyLoading, replaceWhitespace } from '@grandvisionhq/utils';
import { useAlgoliaSearch } from '../Algolia/hooks/use-algolia-search.js';
import { AlgoliaCrossSellProducts } from './AlgoliaCrossSellProducts.js';
import { getGraphAlgoliaFilters } from './utils/get-graph-algolia-filters.js';

// This is the GraphQL version of the CrossSellProducts
const GraphCrossSellProducts = ({ activeVariant , product: product1 , algoliaConfig ,  })=>{
    const { facets  } = algoliaConfig;
    const activeSku = activeVariant.sku;
    const { currency , locale , getLabel  } = useIntl();
    const { filters , optionalFilters  } = React.useMemo(()=>getGraphAlgoliaFilters(product1, activeVariant, facets, activeSku, locale)
    , [
        product1,
        facets,
        activeSku,
        locale
    ]);
    // QueryParameters to be sent to Algolia
    const searchOptions = React.useMemo(()=>{
        const lensRules = [];
        if (isContactLensVariant(activeVariant)) {
            activeVariant.replacementFrequency && lensRules.push(`cs-${replaceWhitespace(activeVariant.replacementFrequency, '_')}`);
            activeVariant.lensType && lensRules.push(`cs-${replaceWhitespace(activeVariant.lensType, '_')}`);
        }
        const ruleContexts = [
            ...lensRules,
            `cs-${product1.productType.toLowerCase()}`,
            `cs-${activeSku}`,
            `cs-${replaceWhitespace(product1.brandName, '_')}`, 
        ];
        return {
            filters,
            optionalFilters,
            hitsPerPage: 10,
            ruleContexts
        };
    }, [
        filters,
        optionalFilters,
        product1.productType,
        activeSku,
        activeVariant
    ]);
    const { result , isLoading , hasError  } = useAlgoliaSearch(algoliaConfig, searchOptions);
    const isVisible = result.length > 0 && !isLoading && !hasError;
    const showLoader = result.length === 0 && isLoading;
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [
        currency
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [
        currency
    ]);
    return showLoader || isVisible ? /*#__PURE__*/ React.createElement(AlgoliaCrossSellProducts, {
        title: getLabel('products.crossSell.title'),
        result: result,
        isLoading: isLoading,
        handleImpression: handleImpression,
        handleInteraction: handleInteraction
    }) : null;
};
var GraphCrossSellProducts$1 = withLazyLoading(GraphCrossSellProducts);

export { GraphCrossSellProducts$1 as default };
//# sourceMappingURL=GraphCrossSellProducts.js.map
